/*
# View for potentials transfers
*/

define(['jquery', 'core', 'app-common/component/loader', 'app-common/component/api-call', 'app-common/component/confirm-dialog', 'template/document-entry/transfers-list.htm'], function($, core, loader, apiCall, confirmDialog, transfersListTemplate) {
  var TransfersList;
  return TransfersList = (function() {

    TransfersList.prototype.jeId = null;

    function TransfersList(options) {
      var promise,
        _this = this;
      this.jeId = options.jeId;
      loader.init();
      promise = apiCall('document', this.jeId + '/transactions_for_matching/');
      promise.always(function(response) {
        loader.hide();
        confirmDialog.init(_.template(transfersListTemplate, {
          transactions: response
        }), {
          ok: 'Ok',
          cancel: 'Cancel'
        }, true);
        return $('.confirm-ok').on('click', function() {
          return _this.linkTransfer();
        });
      });
    }

    TransfersList.prototype.linkTransfer = function() {
      var linkedTransfer, promise,
        _this = this;
      linkedTransfer = $('input[name=selected_transfer]:checked').val();
      if (linkedTransfer != null) {
        loader.init();
        promise = apiCall('document', this.jeId + '/link_transfer/' + linkedTransfer, 'PUT');
        return promise.always(function() {
          loader.hide();
          _this.hide();
          return core.getRouter().loadPage('document-entry', [_this.jeId]);
        });
      }
    };

    TransfersList.prototype.hide = function() {
      return $('#confirm-dialog').modal('hide');
    };

    return TransfersList;

  })();
});
